<template>
  <div>
    <div style="background-color: white;overflow:hidden;border-top:1px solid #F7F7F7">
      <div class="Specifications">
        <label style="color: #8E8E8E;font-size: 90%">品规: {{ drugNumber }}</label>
        <label class="fontPadding">总数量: {{ totalNumbers }}</label>
      </div>
    </div>
    <div style="background-color: white">
      <van-cell-group  :border="false">
        <div style="margin-top: 1px;border-bottom: 1px solid #F7F7F7">
          <van-cell>
            <van-grid :column-num="4" :border="false">
              <van-grid-item text="药品名称"/>
              <van-grid-item :text="statusFlag?'退货原因':'厂家'"/>
              <van-grid-item text="批号"/>
              <van-grid-item text="数量"/>
              <!--        <van-grid-item v-for="value in 8" :key="value" text="文字" />-->
            </van-grid>
          </van-cell>
        </div>
        <div style="border-bottom: 1px solid #F7F7F7" v-for="(item,index) in orderReturnDetailItems" :key="index" :value="item.QTY">
          <van-cell :url="'/#/spd/returnDrugDetail?drugId='+item.DRUG_ID+'&returnNo='+item.RETURN_NO+'&batchNo='+item.BATCH_NO+'&status='+status">
            <van-grid :column-num="4" gutter="0px" :border="false" square>
              <van-grid-item :text="item.NAME"></van-grid-item>
              <van-grid-item :text="statusList.indexOf(status)>=0?item.rtReason:item.MANUFACTURER"></van-grid-item>
              <van-grid-item :text="item.BATCH_NO"></van-grid-item>
              <van-grid-item :text="item.QTY==null?'0':item.QTY+''"></van-grid-item>
            </van-grid>
          </van-cell>
        </div>
      </van-cell-group>

      <!--      <van-grid  :column-num="4" v-for="value in 4" :key="value">-->
      <!--        <van-grid-item  v-for="value in 4" :key="value" text="value" url="www.baidu.com"/>-->
      <!--      </van-grid>-->

    </div>
  </div>
</template>

<script>
import api from "@/axios/api";
import {mapGetters, mapActions} from "vuex";
import {Toast} from 'vant'

export default {
  name: "orderReturnDetail_body",
  computed: {
    ...mapGetters(["token"])
  },
  watch: {
    token: {
      immediate: true,
      handler: function(val) {
        this.returnNo = this.$route.query.returnNo;
        //this.getOrderDetailByReturnNo();
        if (val) {
          this.getOrderDetailByReturnNo();
        }
      }
    },
    status:{
      immediate: true,
      handler: function(val) {
        //判断状态是否存在
        for (let i =0;i<this.statusList.length;i++){
           if (this.statusList[i] == this.status){
             this.statusFlag = true;
           }
        }
      }
    }
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      returnNo: '',
      drugNumber:0,
      totalNumbers:0,
      orderReturnDetailItems: [],
      isSure:false,  //设置按钮是否启动
      btnText:"确认",
      pass:"",
      statusList:["待提交","OA审批中"],
      statusFlag:false
    }
  },
  props:{
    isPass:{
      type:String,
      required:true
    },
    status:{
      type:String,
      required: true
    }
  },
  methods: {
    getOrderDetailByReturnNo: function () {
      let params = {
        returnNo: this.returnNo,
        isPass: this.isPass
      };
      api.getOrderReturnDetailByReturnNo(params).then((res) => {
        let key = Object.keys(res.result[res.result.length-1]); // 获取键


        if (key == "btnText"){
          //获取btn文字
          //this.btnText = res.result[res.result.length-1].btnText;
          this.$emit('func',res.result.pop().btnText)
        }

        //数据
        this.orderReturnDetailItems = [];
        this.orderReturnDetailItems = res.result;

        //计算品规
        this.drugNumber = res.result.length;
        let total = 0;
        for (let i = 0; i < res.result.length; i++) {
          total += parseInt(res.result[i].QTY==null?'0':res.result[i].QTY);
        }
        this.totalNumbers = total;
        this.$forceUpdate();
      })
    },

  },
  mounted() {
    this.returnNo = this.$route.query.returnNo;
  }
}
</script>

<style scoped>
.Specifications {
  float: left;
  margin-left: 3%;
  margin-top: 1%;
  padding-top: 10px;
  height: 30px;
}

.fontPadding {
  margin-left: 40px;
  color: #8E8E8E;
  font-size: 90%
}



.van-cell{
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/spd/orderReturnDetail_body.vue